import PropTypes from 'prop-types';
import { useState } from 'react';

import Button from '../Button';
import IconDelete from '../Icons/IconDelete';
import IconEdit from '../Icons/IconEdit';
import SelectBase from '../SelectBase';

const CitizenshipItemBox = ({
  options,
  selectedOption,
  buttonId,
  updateCitizenship,
  removeCitizenship,
}) => {
  const [editState, setEditState] = useState(false);
  const [selected, setSelected] = useState(selectedOption);

  const setCountry = val => {
    setSelected(val);
  };

  const buttonHandler = () => {
    removeCitizenship(buttonId);
  };

  const saveCitizenship = () => {
    if (!selected) return;
    updateCitizenship(selected, buttonId);
    setEditState(false);
  };

  return (
    <li className="item-box" aria-label="citizen-item">
      {editState ? (
        <div>
          <SelectBase
            selectedValue={selected}
            onChange={setCountry}
            options={[selectedOption, ...options]}
            placeholder="Search for your country"
            noOptionsMessage="We couldn't find that country."
            label="Citizenship"
          />

          {selectedOption && (
            <div className="row-spacer flex gap-4 w-full">
              <Button
                type="button"
                className="niso-button cancel-button"
                onClick={() => setEditState(false)}
              >
                Cancel
              </Button>
              <Button
                type="button"
                aria-label="save button"
                className="niso-button save-button"
                onClick={saveCitizenship}
              >
                Save
              </Button>
            </div>
          )}
        </div>
      ) : (
        <>
          <div>
            <p className="item-box__title desktop-d-body">{selectedOption.label}</p>
          </div>
          <div>
            <button
              type="button"
              onClick={buttonHandler}
              aria-label="remove citizen item"
              id={buttonId}
            >
              <IconDelete />
            </button>
          </div>
          <div>
            <button type="button" aria-label="edit citizen item" onClick={() => setEditState(true)}>
              <IconEdit />
            </button>
          </div>
        </>
      )}
    </li>
  );
};

CitizenshipItemBox.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      currency: PropTypes.string.isRequired,
    }),
  ),
  selectedOption: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
  }),
  buttonId: PropTypes.number.isRequired,
  updateCitizenship: PropTypes.func.isRequired,
  removeCitizenship: PropTypes.func.isRequired,
};

export default CitizenshipItemBox;
